import React, { useEffect } from "react";
import { useTabs } from "../../hooks/useTabs";
import Label from "../../ui/Label";
import Input from "../../ui/Input";
import Space from "../../ui/Space";
import { KBD } from "../../utils/Keybindings";
import { listen } from "../../hooks/Listener";
import { apiCall } from "../../utils/Api";
import { showError } from "../../ui/Message";
import { pubCall } from "../../utils/PubSub";

export default function NoSale(props) {

    const { controller = "", route = "", clerk_code = "", callback = () => { } } = props;

    const defaultTabs = [
        { label: "reason", key: "reason", value: "" },
        { label: "receipt", key: "receipt", value: "N" },
    ]


    const {
        tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs
    } = useTabs(defaultTabs, "reason");


    const blurField = (_field = index) => {
        const el = refs.current[_field];
        if (el && typeof el.blur === 'function') {
            el.blur();
        }
    }

    const focusField = (_field = index) => {
        const el = refs.current[_field];
        if (el && typeof el.focus === 'function') {
            el.focus();
        }
    }


    useEffect(() => {
        focusField()
    }, [index])

    const saveTransaction = () => {

        let obj = {
            clerk_code: clerk_code,
            reason: getVal("reason"),
            want_receipt: (getVal("receipt") === "Y") ? true : false,
        }

        pubCall("point_of_sale.noSaleTransaction", obj, (_s, _r) => {
            if (_s) {
                callback(_r);
            } else {
                showError(_r);
            }
        })

    }


    const tender_actions = [
        { key: KBD.ESCAPE, action: () => callback() },
        { key: KBD.ARROW_DOWN, action: () => next() },
        { key: KBD.ARROW_UP, action: () => prev() },
        { key: KBD.PAGE_DOWN, action: () => saveTransaction() },
    ];


    useEffect(() => {
        const cleanup = listen(controller, route, tender_actions, false, [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.PAGE_DOWN, KBD.PAGE_UP, KBD.ESCAPE, KBD.MINUS]);
        return cleanup;
    }, [tabs, index]);





    return (
        <>
            <div className="shim" /><div className="shim" />
            <Space size={8}>
                <Label width={210}><nobr>Reason for opening cash drawer: </nobr></Label>
                <Input maxLength={32} {...editProps("reason")} grow width={100} />
            </Space>
            <div className="shim" /><div className="shim" />
            <Space size={8}>
                <Label width={210}><nobr>Do you need a paper receipt?</nobr></Label>
                <Input
                    {...editProps("receipt")}
                    uppercase
                    maxLength={1}
                    chars={["Y", "N"]}
                    width={14}
                />
            </Space>
        </>
    )
}